import { documents } from "./documents";

export const dashboardStats = {
  documents_with_findings: 6,
  all_documents: documents.length,
  applications: 4,
  anomalous_users: 1,
  total_users: 3,
};
